(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["hem-med-terra"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('hem-carousel')) {
    class HemCarousel extends HTMLElement {
      connectedCallback() {
        this.track = this.querySelector('.hem__track');
        this.arrows = [...this.querySelectorAll('.hem__arrow')];
        this.onScroll = () => {
          cancelAnimationFrame(this.raf);
          this.raf = requestAnimationFrame(() => this.update());
        };
        this.track.addEventListener('scroll', this.onScroll, { passive: true });
        this.arrows.forEach((btn) => btn.addEventListener('click', () => this.go(Number(btn.dataset.dir))));
        this.resizeObserver = new ResizeObserver(this.onScroll);
        this.resizeObserver.observe(this.track);
        this.update();
      }

      disconnectedCallback() {
        this.resizeObserver?.disconnect();
      }

      // Page by the number of whole cards in view, so nothing is skipped
      go(dir) {
        const card = this.track.querySelector('.hem__card');
        if (!card) return;
        const gap = parseFloat(getComputedStyle(this.track).columnGap) || 0;
        const step = card.offsetWidth + gap;
        const visible = Math.max(1, Math.floor((this.track.clientWidth + gap) / step));
        this.track.scrollBy({ left: dir * visible * step });
      }

      update() {
        const { scrollLeft, scrollWidth, clientWidth } = this.track;
        const [prev, next] = this.arrows;
        if (prev) prev.disabled = scrollLeft <= 2;
        if (next) next.disabled = scrollLeft + clientWidth >= scrollWidth - 2;
      }
    }
    customElements.define('hem-carousel', HemCarousel);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lookbook"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('lookbook-gallery')) {
    class LookbookGallery extends HTMLElement {
      connectedCallback() {
        this.grid = this.querySelector('.lookbook__grid');
        this.cells = [...this.grid.querySelectorAll('.lookbook__item')];
        this.more = this.querySelector('.lookbook__more');
        this.expanded = false;

        this.mq = window.matchMedia('(min-width: 769px)');
        this.onBreakpoint = () => this.layout();
        this.mq.addEventListener('change', this.onBreakpoint);

        this.more?.querySelector('button').addEventListener('click', () => {
          this.expanded = true;
          this.layout();
        });

        this.layout();
      }

      disconnectedCallback() {
        this.mq?.removeEventListener('change', this.onBreakpoint);
      }

      get isCarousel() {
        return !this.mq.matches && this.dataset.carousel === 'true';
      }

      applyLimit() {
        const limit = this.isCarousel || this.expanded
          ? 0
          : parseInt(this.mq.matches ? this.dataset.limitD : this.dataset.limitM, 10) || 0;
        this.cells.forEach((cell, i) => { cell.hidden = limit > 0 && i >= limit; });
        if (this.more) this.more.hidden = !(limit > 0 && this.cells.length > limit);
      }

      /* Masonry: measure heights in the CSS-columns fallback (images carry
         width/height, so this works before they load), then place each photo
         in the shortest column, preferring the leftmost on near-ties. */
      layout() {
        this.applyLimit();
        this.grid.classList.remove('is-laid');
        this.grid.replaceChildren(...this.cells);

        if (this.dataset.masonry !== 'true' || this.isCarousel) return;
        const count = parseInt(getComputedStyle(this).getPropertyValue(this.mq.matches ? '--lb-cols-d' : '--lb-cols-m'), 10) || 1;
        if (count < 2) return;

        const visible = this.cells.filter((cell) => !cell.hidden);
        const heights = visible.map((cell) => cell.offsetHeight);
        const cols = Array.from({ length: count }, () => {
          const col = document.createElement('div');
          col.className = 'lookbook__col';
          return col;
        });
        const totals = new Array(count).fill(0);
        visible.forEach((cell, i) => {
          let target = 0;
          for (let c = 1; c < count; c++) if (totals[c] < totals[target] - 40) target = c;
          cols[target].append(cell);
          totals[target] += heights[i];
        });
        // Hidden cells stay in the DOM so the theme editor can still select them
        cols[0].append(...this.cells.filter((cell) => cell.hidden));
        this.grid.replaceChildren(...cols);
        this.grid.classList.add('is-laid');
      }
    }
    customElements.define('lookbook-gallery', LookbookGallery);
  }

  } catch(e) { console.error(e); }
})();
})();
